import React, { lazy } from 'react'

/** Common Components */
import CardSection from '../../../components/ui/card/CardSection';
import RenderTabs from '../../../components/ui/tabs/RenderTabs';

/** Lazily Loaded Components */
const UserWiseReports = lazy(() => import("./feature/UserWiseReport"));
const ProjectWiseReports = lazy(() => import("./feature/ProjectWiseReport"));
const ProjectWiseReportsWithFilter = lazy(() => import("./feature/ProjectWiseReportWithFilter"));

const TimeSheetReportsDetails = () => {
  const tabs = [
    {
      sMenuItemCaption: `User wise Reports`,
      icon: "",
      component: <UserWiseReports />
    },
    {
      sMenuItemCaption: "Project wise Reports",
      icon: "",
      component: <ProjectWiseReports />
    },
    {
      sMenuItemCaption: "Project Timesheet Reports",
      icon: "",
      component: <ProjectWiseReportsWithFilter />
    },
  ];
  return (
    // <div className='center-top-space'>
      <CardSection cardTitle={"Time Sheet Reports"}       >
        <RenderTabs tabs={tabs} />
      </CardSection>
    // </div>
  )
}

export default TimeSheetReportsDetails;
